export type TriggerCategoryId =
  | "scheduled"
  | "email"
  | "slack"
  | "calendar"
  | "crm"
  | "signals";

export const TRIGGER_CATEGORY_ORDER: Array<{
  id: TriggerCategoryId;
  label: string;
}> = [
  { id: "scheduled", label: "Scheduled" },
  { id: "slack", label: "Slack" },
  { id: "email", label: "Email" },
  { id: "calendar", label: "Calendar" },
  { id: "crm", label: "CRM" },
  { id: "signals", label: "Signals" },
];

/** Curated trigger slugs shown in each category submenu (agent trigger picker). */
export const TRIGGER_CATEGORY_SLUGS: Record<
  TriggerCategoryId,
  readonly string[]
> = {
  scheduled: [
    "schedule.hourly",
    "schedule.daily",
    "schedule.weekly",
    "schedule.monthly",
    // Hidden for now: schedule.custom (cron) isn't supported by the durable
    // scheduler yet (nextFireAt returns null → agent never fires), so don't
    // offer it as a selectable option. Re-add once cron parsing lands.
    // "schedule.custom",
  ],
  email: ["gmail.message.received"],
  slack: ["slack.message.received", "slack.channel.created"],
  calendar: [
    "google_calendar.event.scheduled",
    "google_calendar.event.upcoming",
  ],
  crm: ["account.created", "account.updated"],
  signals: ["account_attribute.updated"],
};

export function triggerCategoryIdForSlug(
  slug: string,
): TriggerCategoryId | null {
  for (const category of TRIGGER_CATEGORY_ORDER) {
    if (TRIGGER_CATEGORY_SLUGS[category.id].includes(slug)) {
      return category.id;
    }
  }
  return null;
}
